import { SlotDayItemForm, SlotInfoCodeDto, SlotItemForm } from '../types/slotPolicy.types';
import { DEFAULT_SLOTS, SLOTINFO_IDX, VAL_KEYS } from '../constants/slotPolicy.constants';

export function parseMinutes(time: string): number | null {
    if (!time || !/^\d{2}:\d{2}$/.test(time)) return null;
    const [h, m] = time.split(':').map(Number);
    if (h < 0 || h > 23 || m < 0 || m > 59) return null;
    return h * 60 + m;
}

export function slotIntervals(startMin: number, endMin: number): [number, number][] {
    if (endMin >= startMin) return [[startMin, endMin + 1]];
    return [[startMin, 1440], [0, endMin + 1]];
}

export function slotsHaveOverlap(slots: { days: SlotDayItemForm[] }[]): boolean {
    for (let dow = 1; dow <= 7; dow++) {
        type Seg = [number, number, number];
        const segs: Seg[] = [];
        for (let i = 0; i < slots.length; i++) {
            const day = slots[i].days.find(d => d.dayOfWeek === dow);
            if (!day) continue;
            const s = parseMinutes(day.startTime);
            const e = parseMinutes(day.endTime);
            if (s === null || e === null) continue;
            for (const [is, ie] of slotIntervals(s, e)) segs.push([is, ie, i]);
        }
        for (let i = 0; i < segs.length; i++) {
            for (let j = i + 1; j < segs.length; j++) {
                if (segs[i][2] === segs[j][2]) continue;
                if (segs[i][0] < segs[j][1] && segs[j][0] < segs[i][1]) return true;
            }
        }
    }
    return false;
}

export const pad2 = (n: number) => String(n).padStart(2, '0');

export const getHour = (time: string): string => {
    if (!time || !/^\d{2}:\d{2}$/.test(time)) return '';
    return String(parseInt(time.slice(0, 2), 10));
};

export const toDateInput = (v: string) =>
    v.length === 8 ? `${v.slice(0, 4)}-${v.slice(4, 6)}-${v.slice(6, 8)}` : '';

export const fromDateInput = (v: string) => v.replace(/-/g, '');

export function applySlotInfoTargets(codes: SlotInfoCodeDto[]): SlotItemForm[] {
    const slots = DEFAULT_SLOTS.map(s => ({
        ...s,
        days: s.days.map(d => ({ ...d })),
    }));
    for (const code of codes) {
        const idx = SLOTINFO_IDX[code.comCode];
        if (idx === undefined) continue;
        slots[idx] = {
            ...slots[idx],
            days: slots[idx].days.map((d, i) => ({
                ...d,
                targetCnt: code[VAL_KEYS[i]] ?? '',
            })),
        };
    }
    return slots;
}
